<template>
  <div>
    <template v-if="isLoading || value === undefined">
      <div class="content">
        <div class="ph-item">
          <div class="ph-col-12">
            <div class="ph-row">
              <div class="ph-col-6 big"></div>
              <div class="ph-col-6 empty big"></div>
              <template v-for="(i, index) in [10, 8, 12, 10, 10, 6, 10, 8]">
                <div :key="index" :class="[`ph-col-${i}`]"></div>
                <div v-if="i != 12" :key="`${index}-12`" :class="[`ph-col-${12-i}`, 'empty']"></div>
              </template>
            </div>
            <div class="ph-row">
              <div class="ph-col-8 big"></div>
              <div class="ph-col-4 empty big"></div>
              <template v-for="(i, index) in [12, 6, 10, 12, 10, 8, 8, 10]">
                <div :key="index" :class="[`ph-col-${i}`]"></div>
                <div v-if="i != 12" :key="`${index}-12`" :class="[`ph-col-${12-i}`, 'empty']"></div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="isEditting">
      <div class="columns is-gapless">
        <div class="column">
          <textarea class="has-fixed-size is-family-monospace description-editor"
              rows="25"
              :value="value"
              v-on:input="update"></textarea>
          <p>
            <a target="_blank" rel="noopener" href="https://guides.github.com/features/mastering-markdown/">
              Markdown Help <span class="icon is-small"><i class="fas fa-external-link-alt"></i></span>
            </a>
          </p>
        </div>
        <div class="column">
          <div class="content description description-preview" v-html="compiledMarkdown"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="content description" v-html="compiledMarkdown"></div>
    </template>
  </div>
</template>
<script>
import marked from 'marked/lib/marked';
import DOMPurify from 'dompurify/dist/purify';

export default {
  name: 'EditableInput',
  props: ['value' ,'isLoading', 'isEditting', 'isSaving', 'isInvalid'],
  methods: {
    update(event) {
      this.$emit('input', event.target.value);
    },
  },
  mounted() {
    this.renderer = new marked.Renderer();
    this.renderer.link = function(href, title, text) {
      const schemePattern = /^(?:[a-z]+:)?\/\//i;
      // Handle links that are relative to the website
      if (!schemePattern.test(href)) {
        if (!href.startsWith('/')) {
          // Add to current URL
          href = `/#${this.$route.path}/${href}`;
        } else {
          href = `/#${href}`;
        }
        return `<a href="${href}">${text}</a>`;
      }
      return `<a target="_blank" rel="noopener" href="${href}">${text} <span class="icon is-small"><i class="fas fa-external-link-alt"></i></span></a>`;
    }.bind(this);
  },
  computed: {
    isInvalidInternal() {
      return this.isInvalid || !this.value;
    },
    compiledMarkdown() {
      // Heavily sanitize - don't allow any HTML right now
      const sanitizedText = DOMPurify.sanitize(this.value, {
        ALLOWED_TAGS: [],
        ALLOWED_ATTR: [],
      });
      return marked(sanitizedText, {
        renderer: this.renderer,
        silent: true
      });
    }
  },
}
</script>
<style scoped>
.ph-item {
  border: none;
}
.description-editor {
  border: none;
  border-right: 1px solid #ccc;
  resize: none;
  outline: none;
  background-color: #f6f6f6;
  padding: 20px;
  width: 100%;
}
.description-preview {
  margin: 20px;
  width: 100%;
}
.description img {
  max-width: 50%;
}
</style>